import React from "react";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";
import step2Img from '../../../../../styles/img/knw-step-2.png';


export const NeedAHelp = () => {
    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="12" className="sb-need-help">
                        <UiContentCol>
                            <h3>Need Help?</h3>
                            <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>
                            <img src={step2Img} />
                        </UiContentCol>
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>
        </>
    )
}